module.exports = __webpack_public_path__ + "img/rightbicep-ectomorph-female.9b2c0a5d.svg";